module.exports = __webpack_public_path__ + "static/media/header-8.1bca88cb.png";